import React from "react";
import { AlertIcon } from "../../../../images/icons/icons";

const FormInput = ({ 
  icon: Icon, 
  label, 
  name, 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  error, 
  disabled = false,
  required = false,
  accept,
  onRef,
  className = ""
}) => {
  const hasValue = (value) => {
    if (typeof value === 'string') return value.trim() !== '';
    if (value instanceof File) return true;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object' && value !== null) return Object.keys(value).length > 0;
    return value !== null && value !== undefined && value !== '';
  };

  return (
    <div className={`staff-onboarding-form-group ${className}`}>
      <label className="staff-onboarding-form-label">
        {Icon && <Icon color="#6B7280" />}
        <span className="staff-onboarding-label-text">
          {label} {required && <span className="staff-onboarding-required">*</span>}
        </span>
      </label>

      <div className={`staff-onboarding-input-wrapper ${error ? "error" : ""} ${disabled ? "disabled" : ""}`}>
        <input
          ref={onRef}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          accept={accept}
          className={`staff-onboarding-input ${hasValue(value) ? 'date-has-value' : ''}`}
        />

        {error && (
          <div className="staff-onboarding-error-message">
            <AlertIcon color="#EF4444" />
            <span>{error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormInput;
